<script>
	console.log('TestProfile component loaded!');
</script>

<div class="p-8">
	<h1 class="text-2xl font-bold">Test Profile Page</h1>
	<p>This is a test to see if routing works.</p>
	<p>Current URL: {window.location.href}</p>
</div>
